'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fullPathSelector = exports.querySelectorRaw = exports.querySelector = exports.pathSelector = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pathSelector = exports.pathSelector = function pathSelector(state) {
  return state.request.path;
};
var querySelector = exports.querySelector = function querySelector(state) {
  return state.request.query;
};
var querySelectorRaw = exports.querySelectorRaw = function querySelectorRaw(state) {
  var currentFullUrl = state.request.currentFullUrl;

  var _ref = currentFullUrl.match(/\?.*$/) || '',
      _ref2 = (0, _slicedToArray3.default)(_ref, 1),
      queryString = _ref2[0];

  return queryString || '';
};

var fullPathSelector = exports.fullPathSelector = function fullPathSelector(state) {
  var _state$request = state.request,
      currentFullUrl = _state$request.currentFullUrl,
      hostname = _state$request.hostname;


  return currentFullUrl.replace(new RegExp('^https?://' + hostname + '(:\\d+)?/'), '/');
};